import React, { useState } from 'react';

const LabourRatesExportModal = ({ onClose, data }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    try {
      setExporting(true);
      const headers = ['Account #', 'DS Trade', 'DS Work Schedule', 'DS Nb Day', 'DS Straight', 'DS Overtime',
        'DS Double', 'DS Total Wages', 'DS Addition', 'DS Blank', 'DS Notes', 'Column1',
        'NS Trade', 'NS Work Schedule', 'NS Nb Day', 'NS Straight', 'NS Overtime',
        'NS Double', 'NS Total Wages', 'NS Addition', 'NS Blank', 'NS Notes'];
      const keys = ['account_number', 'ds_trade', 'ds_work_schedule', 'ds_nb_day', 'ds_straight', 'ds_overtime',
        'ds_double', 'ds_total_wages', 'ds_addition', 'ds_blank', 'ds_notes', 'column1',
        'ns_trade', 'ns_work_schedule', 'ns_nb_day', 'ns_straight', 'ns_overtime',
        'ns_double', 'ns_total_wages', 'ns_addition', 'ns_blank', 'ns_notes'];
      
      let csv = headers.join(',') + '\n';
      data.forEach(row => {
        csv += keys.map(k => {
          const val = row[k] ?? '';
          return typeof val === 'string' && (val.includes(',') || val.includes('"')) ? `"${val.replace(/"/g, '""')}"` : val;
        }).join(',') + '\n';
      });
      
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `labour_rates_${new Date().toISOString().split('T')[0]}.csv`;
      a.click();
      URL.revokeObjectURL(url);
      onClose();
    } catch (err) {
      alert('Export failed: ' + err.message);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: '#2a2a3a', padding: '30px', borderRadius: '8px', minWidth: '400px' }}>
        <h3 style={{ color: '#fff', marginTop: 0 }}>Export Labour Rates</h3>
        <p style={{ color: '#ccc' }}>Export {data.length} records to CSV file?</p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
          <button onClick={handleExport} disabled={exporting} style={{ padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>{exporting ? 'Exporting...' : 'Export'}</button>
        </div>
      </div>
    </div>
  );
};

export default LabourRatesExportModal;

